import { InfoWindow, Marker, MarkerClusterer } from "@react-google-maps/api"
import { pick } from "lodash-es"
import React, { useRef, useState } from "react"
import { renderToString } from "react-dom/server"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { TripStatusMap } from "graphql/types/custom.types"
import { VEHICLE_CLOSE_FILTER } from "store/vehicle.redux"
import AppToaster from "utils/AppToaster"
import { pascalCase } from "utils/custom.utils"
import formatAddress from "utils/googleMaps"
import TripInfo from "./TripInfo"
import TripsAggregateInfo from "./TripsAggregateInfo"
import { useOffsetMarkers } from "utils/offsetMarkers.utils"
function MapMarkers({ availableTrips: at }) {
  const availableTrips = useOffsetMarkers(at)

  const infoWindowRef = useRef(null)
  const [hoveredTrip, setHoveredTrip] = useState(null)
  const isFilterOpen = useSelector(state => state.vehicle.isFilterOpen)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  function handleClick(_, trip) {
    navigate(`/d/vehicle/trip/${trip}`)
    if (isFilterOpen) {
      dispatch({
        type: VEHICLE_CLOSE_FILTER,
      })
    }
  }
  return (
    <>
      <MarkerClusterer
        onMouseOut={e => {
          setHoveredTrip(null)
        }}
        onMouseOver={clusterer => {
          setHoveredTrip({
            lat: clusterer.center.lat(),
            lng: clusterer.center.lng(),
          })

          const newPos = clusterer?.getCenter().toJSON()
          const geocoder = new window.google.maps.Geocoder()
          geocoder.geocode({ location: newPos }, (result, status) => {
            if (status !== "OK") {
              AppToaster.show({
                message: "Unable to load the map results",
                intent: "warning",
              })
            } else {
              const addressComponent = result[0].address_components
              const address = formatAddress(addressComponent)
              infoWindowRef.current &&
                infoWindowRef.current.setContent(
                  renderToString(
                    <TripsAggregateInfo
                      zoom={clusterer?.map?.zoom}
                      vehicles={clusterer?.markers?.length}
                      address={address}
                    />
                  )
                )
            }
          })
        }}
      >
        {clusterer => {
          return availableTrips?.map((trip, idx) => {
            // Converts OC to OnCompleted
            // for eg.
            const status = pascalCase(TripStatusMap[trip.status])
            return (
              <Marker
                onMouseOut={e => {
                  setHoveredTrip(null)
                }}
                onMouseOver={e => {
                  if (e) {
                    setHoveredTrip({
                      lat: e?.latLng?.lat(),
                      lng: e?.latLng?.lng(),
                      uuid: trip.uuid,
                    })

                    // Set the info window above the marker with the appropriate date
                    // notice we are using renderToString method to render the content as string
                    // As google maps api does not support react elements directly
                    infoWindowRef.current.setContent(
                      renderToString(<TripInfo tripData={trip} />)
                    )
                  }
                }}
                icon={{
                  url: `https://cdn.vesatogo.com/images/${status}Status.svg`,
                  scaledSize: new window.google.maps.Size(22, 22),
                }}
                animation={window.google.maps.Animation.DROP}
                title={trip.uuid}
                key={trip.uuid ?? idx}
                position={{
                  lat: trip?.latitude,
                  lng: trip?.longitude,
                }}
                clusterer={clusterer}
                onClick={e => handleClick(e, trip.uuid)}
              />
            )
          })
        }}
      </MarkerClusterer>
      {hoveredTrip ? (
        <InfoWindow
          onLoad={infoWindow => {
            infoWindowRef.current = infoWindow
          }}
          onCloseClick={_ => setHoveredTrip(null)}
          position={pick(hoveredTrip, ["lat", "lng"])}
        >
          <TripInfo tripData={null} />
        </InfoWindow>
      ) : null}
    </>
  )
}

export default MapMarkers
